<template>
  <div v-if="commentsInfo && show" class="panel">
    <a id="comm" name="comm"></a>
    <div class="panel-title">评论（{{ commentsInfo.commentsCount }}）</div>
    <el-form class="comment" label-width="46px">
      <el-form-item label="评论">
        <el-input
          type="textarea"
          :rows="3"
          v-model="comment"
          :disabled="disabled || disableComment"
          class="comment-textarea"
          :placeholder="displayPlaceholder"
          :maxlength="300"
        ></el-input>
        <div v-show="replyId" ref="replyHead" class="reply-head">
          回复 {{ replyName }}：
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
          :disabled="disabled || disableComment"
          :loading="commentSubmitting"
          >提交评论</el-button
        ></el-form-item
      >
    </el-form>

    <ul class="comment-list">
      <li
        v-for="(item, index) in commentList"
        :key="item.id"
        class="comment-item"
      >
        <div
          class="avatar"
          :style="{ backgroundImage: `url(${item.avatar})` }"
        ></div>
        <div class="comment-right">
          <div class="comment-container">
            <div class="nick-name">{{ item.nickname }}</div>
            <div class="content">{{ item.content }}</div>
            <div class="date">
              {{ dayjs(item.createTime).format('YYYY-MM-DD HH:mm') }}
              <span
                v-if="userInfo && userInfo.userId === item.userId"
                @click="delComment(item)"
                >删除</span
              >
            </div>
            <div class="reply" @click="reply(item.id, item.nickname)">回复</div>
          </div>
          <ul v-if="item.subComments" class="sub-comments">
            <li
              v-for="subComment in item.displaySubComments"
              :key="subComment.id"
              class="sub-comment-item"
            >
              <div class="nick-name">
                {{ subComment.nickname }}
                <template v-if="subComment.parentComent"
                  >回复
                  <span>{{ subComment.parentComent.nickname }}</span>
                </template>
              </div>
              <div class="content">{{ subComment.content }}</div>
              <div class="date">
                {{ dayjs(subComment.createTime).format('YYYY-MM-DD HH:mm') }}
                <span
                  v-if="userInfo && userInfo.userId === subComment.userId"
                  @click="delComment(subComment)"
                  >删除</span
                >
              </div>
              <div
                class="reply"
                @click="reply(subComment.id, subComment.nickname)"
              >
                回复
              </div>
            </li>
            <li
              v-if="item.surplusSubComments > 0"
              class="surplus-sub-comments"
              @click="unfoldSubComments(index)"
            >
              查看剩余
              <span>{{ item.surplusSubComments }}</span>
              条回复
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  createComments,
  getComments,
  getSubComments,
  deleteComment
} from '@/api/comments'
import dayjs from 'dayjs'

export default {
  name: 'CommentList',
  props: {
    commentsInfo: Object,
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: '请输入评论内容（300字）'
    }
  },
  data() {
    return {
      /**
       * 评论内容
       */
      comment: '',
      show: true,
      commentSubmitting: false,
      commentList: [],
      replyId: 0,
      replyName: ''
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
    disableComment() {
      let _disableComment = true
      if (this.commentsInfo) {
        _disableComment = !(this.commentsInfo.commentOptions === 0)
      }

      return _disableComment
    },
    displayPlaceholder() {
      let _placeholder = '请输入评论内容（300字）'
      if (!this.isLogin) {
        _placeholder = '请登录后再发布评论'
      } else if (this.disabled) {
        _placeholder = '订阅后可评论'
      } else if (this.commentsInfo) {
        if (this.commentsInfo.commentOptions === 3) {
          _placeholder = '匿名用户无法评论'
        } else if (this.commentsInfo.commentOptions === 4) {
          _placeholder = '您已被禁言'
        } else if (this.commentsInfo.commentOptions === 0) {
          _placeholder = '请输入评论内容（300字）'
        } else {
          _placeholder = '无法评论'
        }
      }

      return _placeholder
    },
    userInfo() {
      return this.$store.state.user.userInfo
    }
  },
  watch: {
    commentsInfo: {
      immediate: true,
      handler(val) {
        if (val.commentOptions === 1 || val.commentOptions === 2) {
          this.show = false
          return
        }
        if (val) {
          this.getComments(val.topicId)
        }
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', event => {
      if (
        event.keyCode === 8 ||
        event.keyCode === 46 ||
        event.code === 'Backspace' ||
        event.code === 'Delete'
      ) {
        if (this.replyId && this.replyHeadEl && !this.comment) {
          if (
            document.activeElement &&
            document.activeElement.tagName === 'TEXTAREA'
          ) {
            this.resetReplyHead()
          }
        }
      }
    })

    // 锚点
    var hash = window.location.hash
    if (hash) {
      document.querySelector(hash).scrollIntoView(true)
    }
  },
  created() {},
  methods: {
    dayjs,
    async onSubmit() {
      if (!this.comment) {
        this.$message.error('评论内容不能为空')
        return
      }

      this.commentSubmitting = true

      await this.createComments(this.comment, this.replyId)

      this.commentSubmitting = false
      this.comment = ''
    },
    initReplyHead() {
      this.replyHeadEl = this.replyHeadEl || this.$refs.replyHead
      this.textareaEl =
        this.textareaEl || document.querySelector('textarea.el-textarea__inner')

      setTimeout(() => {
        this.textareaEl.style.textIndent =
          this.replyHeadEl.clientWidth - 15 + 'px'
        this.textareaEl.focus()
      }, 50)
    },
    resetReplyHead() {
      this.replyId = 0
      this.replyName = ''
      this.textareaEl.style.textIndent = '0px'
    },
    async reply(replyId, replyName) {
      // await this.createComments(this.comment)
      if (this.disabled || this.disableComment) {
        this.$toasted.show(this.displayPlaceholder, {
          position: 'bottom-center',
          duration: 3000
        })

        return
      }

      this.replyId = replyId
      this.replyName = replyName

      this.initReplyHead()
    },
    async createComments(content, replyId) {
      const params = {
        topicId: this.commentsInfo.topicId,
        content
      }

      // 回复
      if (replyId) {
        params.parentCommentId = replyId
      }
      let detail = null
      const data = await createComments(params)

      if (data.result.code === 0) {
        this.getComments(this.commentsInfo.topicId)
        detail = data.detail
        if (this.replyId) {
          this.resetReplyHead()
        }
      } else {
        this.$message.error(data.result.msg)
      }

      return detail
    },
    async delComment(item) {
      // this.$message.info('id:' + item.id + ',content:' + item.content)
      const { result, detail } = await deleteComment(item.id)
      if (result.code === 0) {
        if (detail) {
          // const index = this.commentList.findIndex(x => x.id === item.id)
          // if (index !== -1) {
          //   this.commentList.splice(index, 1)
          // }
          this.getComments(this.commentsInfo.topicId)
          this.$message.success('删除成功')
        }
      } else {
        this.$message.error(result.msg)
      }
    },
    async getSubComments(commentId) {
      return await getSubComments(commentId)
    },
    async getComments(topicId) {
      const data = await getComments(topicId)
      if (data.result.code === 0) {
        const list = data.detail.list
        const result = []
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          if (item.replyCount > 0) {
            item.collapse = true
            item.subComments = await this.getSubComments(item.id)
            item.displaySubComments =
              item.subComments.length > 3
                ? item.subComments.slice(0, 3)
                : item.subComments.slice(0)
            item.surplusSubComments = item.subComments.length - 3
          }
          result.push(item)
        }

        this.commentList = data.detail.list
      }
    },
    /**
     * 展开全部的子评论
     * @param index
     */
    unfoldSubComments(index) {
      const current = this.commentList[index]

      this.commentList.splice(index, 1, {
        ...current,
        displaySubComments: current.subComments.slice(0),
        surplusSubComments: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  margin: 40px 0;
  padding: 0 20px;
  min-height: 186px;
  border: solid 1px #ebebeb;

  .panel-title {
    display: flex;
    align-items: center;
    height: 60px;
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    border-bottom: solid 1px #ebebeb;
  }
}

.comment {
  margin-top: 20px;

  ::v-deep {
    .el-form-item__label {
      text-align: left;
    }
  }
}

.reply-head {
  position: absolute;
  left: 0;
  top: 0;
  line-height: 24px;
  padding: 5px 0 5px 15px;
  font-size: 14px;
  box-sizing: content-box;
  color: #858585;
  pointer-events: none;
}

.comment-textarea {
  ::v-deep {
    .el-textarea__inner {
      line-height: 24px;
      padding: 5px 15px;
      font-size: 14px;
    }
  }
}

.comment-list {
  margin-left: -8px;
  padding-bottom: 20px;
}

.comment-item {
  position: relative;
  display: flex;
  padding: 15px 0;
}

.avatar {
  width: 40px;
  height: 40px;
  margin-right: 16px;
  background: no-repeat center;
  background-size: contain;
  border-radius: 50%;
}

.nick-name {
  font-size: 14px;
  color: #262626;
}

.content {
  font-size: 14px;
  line-height: 24px;
  color: #262626;
  padding: 8px 0;
}

.date {
  font-size: 12px;
  color: #858585;
}

.date > span {
  font-size: 12px;
  color: #858585;
  margin-left: 12px;
  cursor: pointer;
}

.reply {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 12px;
  color: #262626;
  cursor: pointer;
}

.comment-right {
  flex: auto;
}

.comment-container {
  position: relative;
}

.sub-comments {
  background-color: #fafafa;
  margin: 20px;

  .sub-comment-item {
    position: relative;
    padding: 20px;

    &:nth-child(n + 2) {
      border-top: 1px solid #ebebeb;
    }

    .reply {
      right: 20px;
      bottom: 14px;
    }

    // .nick-name span {
    //   color: #046bcc;
    // }
  }
}

.surplus-sub-comments {
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  text-align: center;
  border-top: 1px solid #ebebeb;
  cursor: pointer;

  span {
    color: #046bcc;
  }
}

.followed {
  background-color: #ebebeb;
  color: #858585;
}
</style>
